module.exports = __webpack_public_path__ + "img/ico-tick.8d6d1fcc.svg";